export const TAB_NAMES = ['basic', 'standard', 'premium'];
